<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="Batch Edit Daily Budget"
        width="600px"
        append-to-body
        :before-close="handleClose">
        <div class="content-wrap ml20">
            <div class="text-color-error mb20">Affects the selected {{list.length}} campaigns</div>
            <el-form ref="form" :model="formItem" :rules="rules" label-width="30px">
               <div class="radio-item">
                   <el-radio v-model="radioType" label="1" @change="changeRadioType">Enter new budget</el-radio>
               </div>
                <el-form-item label="" prop="new_budget" v-if="radioType=='1'">
                    <el-input v-model.trim="formItem.new_budget" placeholder="Please enter an amount" @input="(v)=>(formItem.new_budget=v.replace(/[^\d.]/g,''))" class="form-input"></el-input>
                </el-form-item>

                <div class="radio-item">
                    <el-radio v-model="radioType" label="2" @change="changeRadioType">Increase Budget</el-radio>
                </div>
                <el-form-item label="" prop="add_budget" v-if="radioType=='2'">
                    <el-input :placeholder="formItem.addSelect=='2'?'Please enter a percentage':'请输入预算'" v-model.trim="formItem.add_budget" @input="(v)=>(formItem.add_budget=v.replace(/[^\d.]/g,''))" class="form-input input-with-select">
                        <el-select v-model="formItem.addSelect" slot="prepend" placeholder="Please select">
                            <el-option label="By Amount" value="1"></el-option>
                            <el-option label="By Percentage" value="2"></el-option>
                        </el-select>
                        <span slot="append" v-if="formItem.addSelect=='2'">%</span>
                    </el-input>
                </el-form-item>
                <div class="radio-item">
                    <el-radio v-model="radioType" label="3" @change="changeRadioType">Decrease Budget</el-radio>
                </div>
                <el-form-item label="" prop="less_budget" v-if="radioType=='3'">
                    <el-input :placeholder="formItem.lessSelect=='2'?'Please enter a percentage':'请输入预算'" v-model.trim="formItem.less_budget" @input="(v)=>(formItem.less_budget=v.replace(/[^\d.]/g,''))" class="form-input input-with-select">
                        <el-select v-model="formItem.lessSelect" slot="prepend" placeholder="Please select">
                            <el-option label="By Amount" value="1"></el-option>
                            <el-option label="By Percentage" value="2"></el-option>
                        </el-select>
                        <span slot="append" v-if="formItem.lessSelect=='2'">%</span>
                    </el-input>
                </el-form-item>
            </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button type="default" @click="handleClose" class="action-btn ml20">Cancel</el-button>
            <el-button type="primary" @click="previewBudget" class="action-btn ml20" plain>Preview</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">Apply</el-button>
        </div>


        <el-dialog
            :title="null"
            :visible.sync="notifyVisible"
            :close-on-click-modal=false
            :close-on-press-escape=false
            :show-close=false
            :destroy-on-close=true
            append-to-body
            width="450px"
            custom-class="apple-dialog-err">
            <div>
                <h5 class="tac font16px">Batch Edit Daily Budget Request successful, processing…</h5>
                <p class="tac text-color-error pt10 pb20">Please do not refresh the page, refreshing the page may result in not receiving the latest results in time.</p>
            </div>
        </el-dialog>


        <el-dialog
            :visible.sync="previewVisible"
            :close-on-click-modal="false"
            title="Preview daily budget changes"
            width="800px"
            append-to-body
            class="modal-body-padding-top-20"
            :before-close="previewClose">
            <div class="text-color-error mb20">{{list.length}} campaigns,Daily budget {{actionText}}</div>

            <el-table
                :data="dataList"
                stripe
                :max-height="360"
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                style="width: 100%;min-height: 200px;">
                <el-table-column
                    prop="campaign_name"
                    label="Campaign Name"
                    align="center"
                    min-width="150">
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="Status"
                    align="center"
                    show-overflow-tooltip
                    min-width="150">
                    <template slot-scope="scope">
                        <!--{{scope.row.campaign_status_name}}-->
                        <div :class="getStatusColor(scope.row['campaign_display_status'])">
                            {{scope.row['campaign_serving_state_reasons'] !='-' ? '●' : ''}}{{scope.row['campaign_serving_state_reasons']}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="daily_budget"
                    label="Current Budget"
                    align="center"
                    min-width="150">
                </el-table-column>
                <el-table-column
                    prop="new_budget"
                    label="New Budget"
                    align="center"
                    min-width="150">
                    <template slot-scope="scope">
                        <span class="text-bold">{{scope.row.new_budget}}</span>
                        <p class="font12px">
                            <span v-if="scope.row.diff>0" class="text-color-success">+{{millennialFormat(scope.row.rate)}}%</span>
                            <span v-else-if="scope.row.diff<0" class="text-color-error">{{millennialFormat(scope.row.rate)}}%</span>
                            <span v-else>0.00%</span>
                        </p>
                    </template>
                </el-table-column>
            </el-table>


            <div slot="footer" class="dialog-footer">
                <el-button type="default" @click="previewClose" class="action-btn ml20">Cancel</el-button>
                <el-button type="primary" @click="previewClose" class="action-btn ml20" plain>Edit Daily Budget</el-button>
                <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">Apply</el-button>
            </div>

        </el-dialog>





    </el-dialog>
</template>

<script>
    import API from '@/api/marketManage/apple/index-en';
    import utils from '@/libs/utils.js';
    import { get_flag_mul_err_html,get_err_info } from "../../components/getFlagHtml.js";

    export default {
        name: "BatchBudgetModal",
        props:{
            list:Array,
        },
        data(){
            let _this = this;
            const validateNewBudget = (rule, value, callback)=>{
                if(_this.radioType!='1'){
                    callback();
                }else{
                    if(/^[0-9]\d*(?:\.\d{1,2})?$/.test(value)&&+value>0){
                        if(value>_this.maxVal){
                            // callback(new Error('请输入数值，不可大于142,740,000'));
                            callback();
                        }else{
                            callback();
                        }
                    }else{
                        callback(new Error('Please enter a value, up to two decimal places supported'));
                    }
                }
            };
            const validateAddBudget = (rule, value, callback)=>{
                if(_this.radioType!='2'){
                    callback();
                }else{
                    if(/^[0-9]\d*(?:\.\d{1,2})?$/.test(value)&&+value>0){
                        if(value>_this.maxVal){
                            // callback(new Error('请输入数值，不可大于142,740,000'));
                            callback();
                        }else{
                            callback();
                        }
                    }else{
                        callback(new Error('Please enter a value, up to two decimal places supported'));
                    }
                }
            };
            const validateLessBudget = (rule, value, callback)=>{
                if(_this.radioType!='3'){
                    callback();
                }else{
                    if(/^[0-9]\d*(?:\.\d{1,2})?$/.test(value)&&+value>0){
                        if(value>_this.maxVal){
                            // callback(new Error('请输入数值，不可大于142,740,000'));
                            callback();
                        }else{
                            callback();
                        }
                    }else{
                        callback(new Error('Please enter a value, up to two decimal places supported'));
                    }
                }
            };

            return {
                dialogVisible:false,
                submitLoading:false,
                radioType:'1',

                formItem:{
                    new_budget:'',
                    add_budget:'',
                    less_budget:'',
                    addSelect:'1',
                    lessSelect:'1',
                },
                rules:{
                    new_budget:[
                        { validator: validateNewBudget, trigger: 'blur' },
                    ],
                    add_budget:[
                        { validator: validateAddBudget, trigger: 'blur' },
                    ],
                    less_budget:[
                        { validator: validateLessBudget, trigger: 'blur' },
                    ],
                },


                previewVisible:false,
                maxVal:142740000,
                notifyTip:null,
                notifyVisible:false,
                closeUpdate:false,

            }
        },
        computed:{
            budgetCurrency(){
                let firstRow = this.list[0];
                return firstRow?' '+firstRow.daily_budget_currency:'';
            },
            actionText(){
                if(this.radioType=='1'){
                    return 'will change to '+ +this.formItem.new_budget +this.budgetCurrency;
                }else if(this.radioType=='2'){
                    return 'will increase '+ +this.formItem.add_budget+(this.formItem.addSelect=='1'?this.budgetCurrency:'%');
                }else if(this.radioType=='3') {
                    return 'will decrease '+ +this.formItem.less_budget+(this.formItem.lessSelect=='1'?this.budgetCurrency:'%');
                }
            },
            dataList(){
                let list = this.list||[];
                if(!this.dialogVisible) return list;
                return list.map(item=>{
                    let newBudget = this.getNewBudgetVal(item.daily_budget);
                    let diff = +newBudget - +item.daily_budget;
                    let rate = (diff / item.daily_budget)*100;
                    return {
                        campaign_id:item.campaign_id,
                        campaign_name:item.campaign_name,
                        campaign_status:item.campaign_status,
                        campaign_status_name:item.campaign_status_name,
                        campaign_serving_state_reasons:item.campaign_serving_state_reasons,
                        campaign_display_status:item.campaign_display_status,
                        status:item.status,
                        daily_budget:item.daily_budget,
                        new_budget:newBudget,
                        diff:this.toFixedNum(diff),
                        rate:this.toFixedNum(rate),
                    }
                });
            },
        },
        mounted(){

        },
        methods:{
            handleClose(val){
                console.log('handleClose',val);
                /* 判断关闭时是否需要更新列表 */
                if(this.closeUpdate){
                    this.$emit('update');
                }
                this.dialogVisible = false;
                this.resetForm();
            },
            resetForm(){
                this.closeUpdate = false;
                this.radioType = '1';
                this.formItem.new_budget = '';
                this.formItem.add_budget = '';
                this.formItem.less_budget = '';
                this.formItem.addSelect = '1';
                this.formItem.lessSelect = '1';
                this.$refs.form.clearValidate();
            },

            handleSubmit(){

                this.$refs.form.validate((valid) => {
                    if (valid) {
                        console.log('handleSubmit');

                        // this.notifyTip = this.$notify.success({
                        //     title: 'Batch Edit Daily Budget',
                        //     dangerouslyUseHTMLString: true,
                        //     message: '<p>请求成功，正在处理...</p><p class="text-color-error font12px">Please do not refresh the page, refreshing the page may result in not receiving the latest results in time.</p>',
                        //     duration: 0
                        // });
                        this.notifyVisible = true;
                        this.submitLoading = true;
                        let currency_time = new Date().valueOf();
                        let currentName = `batchCampaignDailyBudget_${currency_time}`;
                        let budgetData = this.dataList.map(item=>{
                            return {
                                campaign_id:item.campaign_id,
                                daily_budget:item.new_budget,

                            }
                        });
                        API.editCampaignDailyBudget({
                            data:budgetData,
                            current_name:currentName,
                        },{
                            timeout: 120 * 1000,
                        }).then(res=>{
                            console.log('editCampaignDailyBudget',res);
                            this.notifyVisible = false;
                            this.submitLoading = false;

                            let resData = res.data||{};
                            let msgText = resData.msg;
                            this.$notify.success({
                                title: resData.info||'Success',
                                dangerouslyUseHTMLString: true,
                                message: '<p>'+msgText+'</p>',
                            });

                            this.previewVisible = false;
                            this.dialogVisible = false;
                            this.$emit('update');
                            this.resetForm();

                        },err=>{
                            console.log('editCampaignDailyBudget err',err);
                            this.notifyVisible = false;
                            this.submitLoading = false;

                            let errData = err.data||{};
                            if(err.code =='403'){
                                this.$confirm(err.info, 'Prompt', {
                                    confirmButtonText: 'Refresh',
                                    cancelButtonText: 'Close',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                    this.loading = false
                                });
                                return
                            }

                            let {errIds, mulErr, mulexc} = get_err_info(errData.data);

                            /* 判断失败或异常的数量，如果失败异常数量不等于提交总条数，表示部分失败，需要更新列表数据 */
                            let uniqueErrIds = Array.from(new Set(errIds));
                            if(uniqueErrIds.length!=budgetData.length){
                                // this.$emit('update');
                                /* 记录关闭弹窗时是否需要更新列表 */
                                this.closeUpdate = true;
                            }

                            let htmlStr=get_flag_mul_err_html(err.info, errData.msg, mulErr, mulexc, currentName, errIds);
                            this.notifyTip = this.$notify({
                                showClose: false,
                                duration: 0,
                                dangerouslyUseHTMLString: true,
                                message: htmlStr,
                                // customClass:'width400',
                            });
                            this.$store.commit('apple/ADD_NOTIFY',{
                                id: `${currentName}_close`,
                                value:this.notifyTip,
                            });
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            showModal(){
                this.dialogVisible = true;
            },
            changeRadioType(){
                this.$refs.form.clearValidate();
            },
            previewClose(){
                console.log('previewClose');
                this.previewVisible = false;
            },
            previewBudget(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.previewVisible = true;
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            getNewBudgetVal(val){

                let newVal = null;
                if(this.radioType=='1'){
                    newVal = this.formItem.new_budget;
                }else if(this.radioType=='2'){
                    console.log('getNewBudgetVal',this.formItem.addSelect,val,this.formItem.add_budget);
                    if(this.formItem.addSelect=='1'){
                        newVal = +val + +this.formItem.add_budget;
                    }else{
                        newVal = +val *(1+this.formItem.add_budget/100);
                    }
                }else if(this.radioType=='3'){
                    console.log('getNewBudgetVal',this.formItem.lessSelect,val,this.formItem.less_budget);
                    if(this.formItem.lessSelect=='1'){
                        newVal = +val - +this.formItem.less_budget;
                    }else{
                        newVal = +val *(1-this.formItem.less_budget/100);
                    }
                }
                newVal = this.toFixedNum(newVal);
                newVal = newVal<=0?0.01:newVal;

                // return Math.min(newVal,this.maxVal);
                return newVal;
            },
            toFixedNum(val){
                if(isNaN(val)) return 0;

                let x = (''+val).indexOf(".")+1;        //得到小数点的位置
                let y = (''+val).length - x;
                if(x!==0&&y>=1){
                    //小数超过两位
                    return (+val).toFixed(Math.min(2,y));
                }else{
                    //没有小数点或者小数点后面有数字
                    return +val;
                }
            },
            millennialFormat(num){
                num = parseFloat(num);
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            },
            // 获取状态颜色
            getStatusColor(val) {
                if(val == 'RUNNING') {
                    return 'text-color-success'
                }else if(val == 'ON_HOLD') {
                    return 'text-color-failed'
                }else{
                    return ''
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .radio-item{
        margin-bottom: 10px;
    }
    .form-input{
        width: 360px;
    }
    .input-with-select ::v-deep .el-input--suffix{
        width: 100px;
    }
</style>
